import React from 'react'
import {Link, NavLink} from 'react-router-dom'
import PropTypes from 'prop-types'
import { calculateAge, patientOlderThenAge } from '../../../../resources/utilities'
import { dataAppDatabase, locale, polyglot } from '../../../../index'
import { CustomLink } from '../../../common/CustomLink/CustomLink'

export default class NavBar extends React.Component {
  constructor (props) {
    super(props)
    this.getPatient = this.getPatient.bind(this)
    this.setPatient = this.setPatient.bind(this)
    this.setPatientAges = this.setPatientAges.bind(this)
    this.setAges = this.setAges.bind(this)
    this.logOut = this.logOut.bind(this)
    this.state = {
      patient: props.patientId,
      ages: props.ages,
      currentPatientAges: props.currentAges
    }
  }

  componentWillReceiveProps (props) {
    if (props.patientId) {
      this.getPatient(props.patientId)
    } else {
      this.setState({
        patient: undefined,
        currentPatientAges: props.currentAges
      })
    }
  }

  logOut () {
    this.props.logOut()
  }

  getPatient (patientNumber) {
    const rootRef = dataAppDatabase.ref()
    const patientRef = rootRef.child('riso').child('patientsByCountry').child(locale)
    let patient = null
    patientRef.on('value', snapshot => {
      snapshot.forEach((childSnap) => {
        if (childSnap.val().patientNumber.toString() === patientNumber) {
          patient = childSnap.val()
        }
      })
      if (patient !== null) {
        this.setPatient(patient)
      }
    })
  }

  setPatient (patient) {
    this.setPatientAges(patient)
    this.setState({
      patient: patient
    })
  }

  setPatientAges (patient) {
    const currentAges = []
    this.state.ages.forEach(function (value) {
      if (patientOlderThenAge(patient.birthDate, value.ageInterval.start)) {
        currentAges.push(value)
      }
    })
    if (currentAges.length > 0) {
      this.setAges(currentAges)
    }
  }

  setAges (ages) {
    const agesState = []
    ages.map(function (value) {
      agesState.push(calculateAge(value.ageInterval))
      return null
    })
    this.setState({currentPatientAges: agesState})
  }

  render () {
    return (
      <nav className='navbar navbar-default'>
        <div className='container-fluid'>
          <div className='navbar-header'>
            <button type='button' className='navbar-toggle collapsed' data-toggle='collapse'
              data-target='#bs-example-navbar-collapse-1' aria-expanded='false'>
              <span className='sr-only'>{polyglot.t('navigationBar.toggleNavigation')}</span>
              <span className='icon-bar' />
              <span className='icon-bar' />
              <span className='icon-bar' />
            </button>
            <Link to='/patients'><img alt={polyglot.t('navigationBar.brand')} className='App-logo' src={polyglot.t('logoData')} /></Link>
          </div>
          {!this.props.patientId && !this.state.patient
            ? <NavigationWithoutPatient logOut={this.logOut} />
            : <NavigationWithPatient
              patientName={this.state.patient && this.state.patient.name}
              setPatient={this.props.setCurrentPatientId}
              patientId={this.props.patientId}
              ages={this.state.currentPatientAges}
              logOut={this.logOut} />
          }
        </div>
      </nav>
    )
  }
}

NavBar.propTypes = {
  setCurrentPatientId: PropTypes.func.isRequired,
  ages: PropTypes.array.isRequired,
  currentAges: PropTypes.array,
  patientId: PropTypes.string,
  logOut: PropTypes.func.isRequired
}

class NavigationWithPatient extends React.Component {
  constructor (props) {
    super(props)
    this.getAgeElements = this.getAgeElements.bind(this)
  }

  getAgeElements (props) {
    if (props.ages) {
      return (
        <ul className='dropdown-menu'>
          {props.ages.map(function (listValue, index) {
            return (
              <li key={index}><NavLink activeClassName='active'
                to={{pathname: `/patients/${props.patientId}/age`, search: '?id=' + listValue.start}}>{listValue.designation}</NavLink>
              </li>
            )
          })}
        </ul>
      )
    } else {
      return (
        <ul className='dropdown-menu'>
          <li>{polyglot.t('navigationBar.withoutAges')}</li>
        </ul>
      )
    }
  }

  logOutPatient () {
    this.props.setPatient(null)
  }

  render () {
    return <div className='collapse navbar-collapse' id='bs-example-navbar-collapse-1'>
      <ul className='nav navbar-nav'>
        <CustomLink exact to={`/patients/${this.props.patientId}/`} label={polyglot.t('navigationBar.home')} />
        <CustomLink to={`/patients/${this.props.patientId}/profile`} label={polyglot.t('navigationBar.patientData')} />
        <CustomLink to={`/patients/${this.props.patientId}/fluor`} label={polyglot.t('navigationBar.fluorRegister')} />
        <li className='dropdown'>
          <a className='dropdown-toggle' data-toggle='dropdown' role='button'
            aria-haspopup='true' aria-expanded='false'>{polyglot.t('navigationBar.ages')}<span className='caret' /></a>
          {this.getAgeElements(this.props)}
        </li>
      </ul>
      <ul className='nav navbar-nav navbar-right'>
        {this.props.patientId
          ? <CustomLink
            to={`/patients/${this.props.patientId}/`}
            label={<div>
              <span className='glyphicon glyphicon-user' />
              {this.props.patientName}
            </div>} />
          : null
        }
        <li className='dropdown'>
          <a className='dropdown-toggle' data-toggle='dropdown' role='button'
            aria-haspopup='true' aria-expanded='false'>{polyglot.t('navigationBar.settings')}<span
              className='caret' /></a>
          <ul className='dropdown-menu'>
            <li>
              <NavLink
                activeClassName='active'
                to='/info' exact
              >{polyglot.t('navigationBar.usefulInformation')}</NavLink>
            </li>
            <li role='separator' className='divider' />
            <li><Link to='/patients' onClick={() => this.logOutPatient()}>{polyglot.t('navigationBar.changePatient')}</Link></li>
            <li><Link to='/patientInsertion' onClick={() => this.logOutPatient()}>{polyglot.t('navigationBar.insertPatient')}</Link></li>
            <li role='separator' className='divider' />
            <li><Link to='/me'>{polyglot.t('navigationBar.doctorProfile')}</Link></li>
            <li><Link to='/settings'>{polyglot.t('navigationBar.settings')}</Link></li>
            <li><Link to='/' onClick={this.props.logOut}>{polyglot.t('navigationBar.logout')}</Link></li>
          </ul>
        </li>
      </ul>
    </div>
  }
}

NavigationWithPatient.propTypes = {
  setPatient: PropTypes.func.isRequired,
  logOut: PropTypes.func.isRequired,
  patientId: PropTypes.string.isRequired,
  patientName: PropTypes.string.isRequired,
  currentAges: PropTypes.array
}

function NavigationWithoutPatient (props) {
  return <div className='collapse navbar-collapse' id='bs-example-navbar-collapse-1'>
    <ul className='nav navbar-nav'>
      <CustomLink to={'/patients'} label={polyglot.t('navigationBar.home')} />
    </ul>
    <ul className='nav navbar-nav navbar-right'>
      <CustomLink to={'/patientInsertion'} label={polyglot.t('navigationBar.insertPatient')} />
      <li className='dropdown'>
        <a href='/patients' className='dropdown-toggle' data-toggle='dropdown' role='button'
          aria-haspopup='true' aria-expanded='false'>{polyglot.t('navigationBar.settings')}<span
            className='caret' /></a>
        <ul className='dropdown-menu'>
          <li><Link to='/settings'>{polyglot.t('navigationBar.settings')}</Link></li>
          <li role='separator' className='divider' />
          <li><Link to='/me'>{polyglot.t('navigationBar.doctorProfile')}</Link></li>
          <li><Link to='/' onClick={props.logOut}>{polyglot.t('navigationBar.logout')}</Link></li>
        </ul>
      </li>
    </ul>
  </div>
}



// WEBPACK FOOTER //
// ./src/components/general/App/Navigation/NavBar.js